import { login } from "./authProvider";
import axios from "../components/common/axios";

const SERVICE_URL = "auth-service/v2/organizations/:orgId";

export const loginUser = async (userData) => {
  return await axios
    .post("auth-service/v2/login", userData)
    .then(function (response) {
      let userData = response.data.response;
      localStorage.setItem("leadUser", JSON.stringify(userData));
      if (userData.roleCode !== "SADM") {
        localStorage.setItem("selectedOrgId", userData.orgId);
      }
      window.dispatchEvent(new Event("storage"));
      let session = {
        refreshToken: userData.refreshToken,
        accessToken: userData.token,
      };
      login(session);
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return {};
    });
};

export const updateToken = async (refreshToken) => {
  const leadUser = JSON.parse(localStorage.getItem("leadUser"));
  const selectedOrgId = JSON.parse(localStorage.getItem("selectedOrgId"));
  let employeeId = leadUser ? leadUser.employeeId : null;
  let data = {
    refreshToken: refreshToken,
    employeeId: employeeId,
  };
  return await axios
    .post(SERVICE_URL.replace(":orgId", selectedOrgId) + "/renew-token", data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return {};
    });
};
